export default "__VITE_ASSET__BJOTRgWQ__"